import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./components/auth/Login.jsx";
import "./App.css";

// The shell is the single public entry point (e.g. school.com).
// After login, it reads the JWT role and redirects the browser to the
// matching micro-frontend's own domain/path:
//   admin  -> admin.school.com
//   staff  -> staff.school.com
//   parent -> parent.school.com
//   student-> student.school.com
// Configure these via REACT_APP_ADMIN_URL etc. in .env.
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/*" element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
}
export default App;
